export const SET_GLOBAL_CONNECTION = "SET_GLOBAL_CONNECTION"
export const SET_IS_SHOW_NOTOFICATION = "SET_IS_SHOW_NOTOFICATION"
export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS"
export const SET_NOTIFICATION = "SET_NOTIFICATION"
export const SET_NOTIFICATION_IS_NOTIFIED = "SET_NOTIFICATION_IS_NOTIFIED"